import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import zhHans from '../lang/zh-Hans.ts'
import en from '../lang/en.ts'
import CustomChecked from '@/components/access/CustomChecked.vue'

Vue.use(Vuetify);
Vue.component('my-component', {
    methods: {
        changeLocale () {
            this.$vuetify.lang.current = 'en'
        }
    }
})
export default new Vuetify({
    icons: {
        iconfont: 'md',
        values: {
            customChecked: { // name of our custom icon
                component: CustomChecked, // our custom component
            },
        },
    },
    lang: {
        locales: { zhHans, en},
        current: 'zhHans',
    }
});
